$(".expand_button").on("click", function() {
    goToByScroll($(this).parent().parent().parent(), 10, 0.5);
    TweenMax.set(".expand_button svg", { 
    	rotation: "0" 
    });
    TweenMax.set(".expand_button svg .st0", { 
        fill: "#00aeef" 
    });
    TweenMax.set(".hidden_content_wrapper", { 
    	display: "none",
    	padding: "0px"
    });
    TweenMax.set($(this).find('svg'), { 
    	rotation: "45" 
    });
    TweenMax.set($(this).find('svg .st0'), { 
        fill: "#577483" 
    });
    TweenMax.set($(this).parent().parent().parent().next(), {
    	display: "block",
    	padding: "10px 0"
    });
});

$(".expandable_row h3").on("click", function() {
    goToByScroll($(this).parent().parent(), 10, 0.5);
    TweenMax.set(".expand_button svg", { 
        rotation: "0" 
    });
    TweenMax.set(".expand_button svg .st0", { 
        fill: "#00aeef" 
    });
    TweenMax.set(".hidden_content_wrapper", { 
        display: "none",
        padding: "0px"
    });
    TweenMax.set($(this).parent().parent().find('svg'), { 
        rotation: "45" 
    });
    TweenMax.set($(this).parent().parent().find('svg .st0'), { 
        fill: "#577483" 
    });
    TweenMax.set($(this).parent().parent().next(), {
        display: "block",
        padding: "10px 0"
    });
});